'use strict'
import api from '@/api/api'
import notify from '@/utils/notify'

const buildQuery = (params = {}) => {
  const q = new URLSearchParams(params).toString()
  return q ? `?${q}` : ''
}

export default {
  async list(params = {}) {
    const data = { method: 'get', url: `review-cycles${buildQuery(params)}` }
    return await api.api(data)
  },

  async getActive() {
    const data = { method: 'get', url: 'review-cycles/active' }
    return await api.api(data)
  },

  async create(json) {
    const data = { method: 'post', url: 'review-cycles', body: json }
    const res = await api.api(data)
    if (res.status === 201 || res.status === 200) notify.alert?.success?.('Review cycle created successfully')
    return res
  },

  async get(id) {
    const data = { method: 'get', url: `review-cycles/${id}` }
    return await api.api(data)
  },

  async update(id, json) {
    const data = { method: 'patch', url: `review-cycles/${id}`, body: json }
    const res = await api.api(data)
    if (res.status === 200) notify.alert?.success?.('Review cycle updated successfully')
    return res
  },

  async destroy(id) {
    const data = { method: 'delete', url: `review-cycles/${id}` }
    const res = await api.api(data)
    if (res.status === 200) notify.alert?.success?.('Review cycle deleted successfully')
    return res
  },

  async activate(id) {
    const data = { method: 'post', url: `review-cycles/${id}/activate` }
    const res = await api.api(data)
    if (res.status === 200) notify.alert?.success?.('Review cycle activated')
    return res
  },
}
